// @flow
import { translate } from '../../../../../react/features/base/i18n/functions';
import Notification from '../../../../../react/features/notifications/components/web/Notification';
import React, { PureComponent } from 'react';

class WizyconfNotification <P: Props> extends PureComponent<P> {
    constructor(props: P) {
        super(props);
    }

    render() {
        const { t, customClass = '', description, titleKey } = this.props;

        return (
            <div className={`wizyconf-notify ${customClass}`}>
                <Notification
                    description = { description }
                    icon = { null }
                    uid = { titleKey }
                    title = { t(titleKey) }
                    onDismissed={() => null}
                />
            </div>
        );
    }
}

export default translate(WizyconfNotification);
